var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarkerGroup = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 50 60",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1{\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #2b2b2b;\n      }\n      \n      .cls-4 {\n        filter: url(#Pfad_7639);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_7639",
    x: 0,
    y: 0,
    width: 70,
    height: 78,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "multiMarker",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7639-2",
    "data-name": "Pfad 7639",
    className: "cls-1",
    d: "M20,0A20,20,0,0,1,40,20c0,8.666-5.511,16.044-13.872,18.989C25.744,39.126,20,48,20,48s-6.175-8.918-6.894-9.161A20.038,20.038,0,0,1,20,0Z",
    transform: "translate(15 15)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    className: "cls-2",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(4 4)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarkerGroup);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/marker-group.6e276de93a802b3bb972097a333316bf.svg";